/* eslint-disable  */
import React from 'react';
import { DialogTitle, DialogContent, DialogActions, DialogContentText, Button } from '@mui/material';

import useTranslation from 'Hooks/useTranslation';
import useUpdate from '../Hooks/useUpdate';
import { colors } from 'Constants/Colors';

export default function ModalEdit({
  data = null,
  cancel = () => {},
  accept = () => {},
  allJobTitles = [],
  setAllJobTitles = () => {},
}) {
  const { t } = useTranslation();
  const { handleClick } = useUpdate({
    data,
    cancel,
    allJobTitles,
    setAllJobTitles,
  });

  return (
    <div className="col">
      <DialogTitle
        style={{
          fontWeight: 'bold',
          color: colors.BLACK,
          fontFamily: 'quicksand',
        }}
      >
        {t('Generic.Edit')} {t('JobTitle.Title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ fontFamily: 'metropolis' }}>{t('JobTitle.DialogMsg')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button style={{ fontFamily: 'quicksand' }} color="success" variant="outlined" onClick={cancel}>
          {t('Generic.Cancel')}
        </Button>
        <Button
          style={{ fontFamily: 'quicksand' }}
          color="success"
          onClick={async () => {
            await handleClick();
            accept();
          }}
          variant="contained"
        >
          {t('Generic.Accept')}
        </Button>
      </DialogActions>
    </div>
  );
}
